import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {ExpertSystemHierarchyNode} from '../types'

export const QueryKey = 'expert-system-hierarchy'

export const useExpertSystemHierarchy = <T = ExpertSystemHierarchyNode>(
  options?: Omit<UseQueryOptions<ExpertSystemHierarchyNode, AxiosError, T>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<ExpertSystemHierarchyNode, AxiosError, T>({
    queryKey: [QueryKey],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ExpertSystemHierarchyNode>(
        '/expert-system/kpis/hierarchy',
        {
          signal
        }
      )

      return response.data
    },
    refetchOnMount: false,
    staleTime: Infinity,
    ...options
  })
}
